export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70282293ee55228c95e00cf1e3b3419983e53a9006&name=pushAdClickData!'